import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AutorechargeFailureBannerStore } from 'entities/Billing/ui/AutorechargeFailureBanner/store/autorechargeFailureBannerStore'

export const AutorechargeFailureBanner = observer(() => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new AutorechargeFailureBannerStore(entities))
  const { show, canManageBilling, init, dispose, initBanner } = store

  useEffect(() => {
    init()

    return () => {
      dispose()
    }
  }, [])

  useEffect(() => {
    initBanner()
  }, [show, canManageBilling])

  return null
})
